"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineOfCoverageCommandStatusReason = exports.LineOfCoverageCommandStatus = exports.LineOfCoverageCommandType = void 0;
var LineOfCoverageCommandType;
(function (LineOfCoverageCommandType) {
    LineOfCoverageCommandType["COPY_SCHEDULED_ITEMS"] = "COPY_SCHEDULED_ITEMS";
    LineOfCoverageCommandType["CREATE"] = "CREATE";
    LineOfCoverageCommandType["MIGRATE"] = "MIGRATE";
    LineOfCoverageCommandType["DELETE"] = "DELETE";
    LineOfCoverageCommandType["UPDATE"] = "UPDATE";
    LineOfCoverageCommandType["UPDATE_DISPLAY_NAME"] = "UPDATE_DISPLAY_NAME";
    LineOfCoverageCommandType["UPDATE_GLOBAL_FIELDS"] = "UPDATE_GLOBAL_FIELDS";
    LineOfCoverageCommandType["UPDATE_DATES"] = "UPDATE_DATES";
    LineOfCoverageCommandType["UPDATE_DATA"] = "UPDATE_DATA";
})(LineOfCoverageCommandType = exports.LineOfCoverageCommandType || (exports.LineOfCoverageCommandType = {}));
var LineOfCoverageCommandStatus;
(function (LineOfCoverageCommandStatus) {
    LineOfCoverageCommandStatus["PENDING"] = "PENDING";
    LineOfCoverageCommandStatus["COMPLETED"] = "COMPLETED";
})(LineOfCoverageCommandStatus = exports.LineOfCoverageCommandStatus || (exports.LineOfCoverageCommandStatus = {}));
var LineOfCoverageCommandStatusReason;
(function (LineOfCoverageCommandStatusReason) {
    LineOfCoverageCommandStatusReason["FAILED"] = "FAILED";
    LineOfCoverageCommandStatusReason["SUCCESSFUL"] = "SUCCESSFUL";
    LineOfCoverageCommandStatusReason["INVALID_LINE_OF_COVERAGE_DATA"] = "INVALID_LINE_OF_COVERAGE_DATA";
})(LineOfCoverageCommandStatusReason = exports.LineOfCoverageCommandStatusReason || (exports.LineOfCoverageCommandStatusReason = {}));
//# sourceMappingURL=line-of-coverage-command.js.map